import { TextPill } from 'components/FbUI/TextPill'
import { RebateOfferType } from './tradespend_api'

const OFFER_TYPE_LABELS: Record<RebateOfferType, string> = {
  // Single-product types (global pricing)
  [RebateOfferType.TOTAL_VALUE]: 'Total Value',
  [RebateOfferType.SINGLE_CASE]: 'Single Case',
  [RebateOfferType.PRICE_PER_CASE]: 'Price per Case',
  [RebateOfferType.MINIMUM_ORDER]: 'Minimum Order',
  // Multi-product types (per-product pricing)
  [RebateOfferType.MULTI_PRODUCT_SAVINGS]: 'Savings Offer',
  [RebateOfferType.MULTI_PRODUCT_CASHBACK]: 'Cash Back Offer',
  [RebateOfferType.MULTI_PRODUCT_TRIAL]: 'Trial Offer',
  [RebateOfferType.MULTI_PRODUCT_CUSTOMER_REBATE]: 'Customer Rebate',
  [RebateOfferType.MULTI_PRODUCT_PROGRAM]: 'Rebate Program',
  // Legacy types
  [RebateOfferType.FIRST_OFFER]: 'First Offer',
  [RebateOfferType.TIME_OFFER]: 'Time Offer',
}

// DS2026 50/700 badge palette — [bg, text]
const PRIMARY_COLORS: [string, string] = ['#dbeafe', '#1d4ed8'] // blue
const SUCCESS_COLORS: [string, string] = ['#dcfce7', '#15803d'] // green
const INFO_COLORS: [string, string] = ['#e0f2fe', '#0369a1'] // sky
const SECONDARY_COLORS: [string, string] = ['#f3f4f6', '#374151'] // gray

interface RebateOfferTypePillProps {
  type: RebateOfferType
}

export function RebateOfferTypePill({ type }: RebateOfferTypePillProps) {
  const label = OFFER_TYPE_LABELS[type]

  const colors = (() => {
    switch (type) {
      // Single-product types
      case RebateOfferType.TOTAL_VALUE:
      case RebateOfferType.SINGLE_CASE:
      case RebateOfferType.PRICE_PER_CASE:
      case RebateOfferType.MINIMUM_ORDER:
        return PRIMARY_COLORS
      // Multi-product types
      case RebateOfferType.MULTI_PRODUCT_SAVINGS:
      case RebateOfferType.MULTI_PRODUCT_CASHBACK:
      case RebateOfferType.MULTI_PRODUCT_TRIAL:
      case RebateOfferType.MULTI_PRODUCT_CUSTOMER_REBATE:
      case RebateOfferType.MULTI_PRODUCT_PROGRAM:
        return SUCCESS_COLORS
      // Legacy types
      case RebateOfferType.FIRST_OFFER:
        return PRIMARY_COLORS
      case RebateOfferType.TIME_OFFER:
        return INFO_COLORS
      default:
        return SECONDARY_COLORS
    }
  })()

  return (
    <TextPill backgroundColor={colors[0]} textColor={colors[1]}>
      {label}
    </TextPill>
  )
}
